import { TransportType } from "@syla/shared/types/helpers/TransportType";
import { GetReferralsResponse } from "@syla/shared/types/responses/GetReferralsResponse";
import axios from "axios";
import { throwSylaApiError } from "../errors/throwSylaApiError";

export async function getReferrals(): Promise<GetReferralsResponse> {
  try {
    const response =
      await axios.get<TransportType<GetReferralsResponse>>("/users/referrals");
    return response.data;
  } catch (error) {
    throwSylaApiError(error);
  }
}
